// extracted by mini-css-extract-plugin
export default {"section":"SourdoughCta_section__s9xGa","label":"SourdoughCta_label__rUWb5","text":"SourdoughCta_text__dRwU-","link":"SourdoughCta_link__DIUcv"};